/**
 * Delivery days of the orders. The expected day is informative: the installer
 * gets the parte once the delivery is confirmed and books the day after.
 */

/** YYYY-MM-DD of a moment, in Spain. */
export const madridDay = (date: Date = new Date()): string =>
  new Intl.DateTimeFormat("en-CA", {
    timeZone: "Europe/Madrid",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);

/** The next working day (Monday to Friday) after a YYYY-MM-DD day. */
export const nextWorkingDay = (day: string): string => {
  const date = new Date(`${day}T12:00:00Z`);
  do {
    date.setUTCDate(date.getUTCDate() + 1);
  } while (date.getUTCDay() === 0 || date.getUTCDay() === 6);
  return date.toISOString().slice(0, 10);
};

/** "jue 22 oct" for a YYYY-MM-DD day. */
export const shortDay = (day?: string | null): string =>
  day
    ? new Date(`${day}T12:00:00Z`).toLocaleDateString("es-ES", {
        weekday: "short",
        day: "numeric",
        month: "short",
        timeZone: "UTC",
      })
    : "";
